import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "small",
      model: _vm.searchForm
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "菜单"
    }
  }, [_c("el-cascader", {
    attrs: {
      options: _vm.menuList,
      props: {
        expandTrigger: "hover",
        label: "menuName",
        value: "id",
        checkStrictly: true
      }
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.searchForm.menuNames,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "menuNames", $$v);
      },
      expression: "searchForm.menuNames"
    }
  })], 1), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.buttonList.length > 0,
      expression: "buttonList.length > 0"
    }],
    attrs: {
      label: "操作"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.buttonId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "buttonId", $$v);
      },
      expression: "searchForm.buttonId"
    }
  }, _vm._l(_vm.buttonList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "开始时间"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.searchForm.startTime,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "startTime", $$v);
      },
      expression: "searchForm.startTime"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "结束时间"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.searchForm.endTime,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "endTime", $$v);
      },
      expression: "searchForm.endTime"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "管理员"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.adminId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "adminId", $$v);
      },
      expression: "searchForm.adminId"
    }
  }, _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userName", $$v);
      },
      expression: "searchForm.userName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "mobile", $$v);
      },
      expression: "searchForm.mobile"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.buttonList = [];
        _vm.searchForm = {
          pageNum: 1,
          pageSize: 20,
          startTime: "",
          endTime: "",
          adminId: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "adminName",
      label: "管理员",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createDate",
      label: "时间",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "menuName",
      label: "菜单",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "operationName",
      label: "操作",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "mobile",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "用户",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "详情",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.operationType == "consult" ? _c("el-link", {
          attrs: {
            href: "#/consult/detail?id=".concat(scope.row.detailBatchNo, "&userId=").concat(scope.row.userId),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.houseCode))]) : _vm._e(), scope.row.operationType == "brand_refund" ? _c("el-link", {
          attrs: {
            href: "#/order/brand?orderId=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "brand_top_up" ? _c("el-link", {
          attrs: {
            href: "#/order/brand?orderId=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "user" ? _c("el-link", {
          attrs: {
            href: "#/user/list?phone=".concat(scope.row.mobile),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v("查看用户详情")]) : _vm._e(), scope.row.operationType == "user_force_realname" ? _c("el-link", {
          attrs: {
            href: "#/user/force-real-name?phone=".concat(scope.row.mobile),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v("查看详情")]) : _vm._e(), scope.row.operationType == "user_device_id" ? _c("el-link", {
          attrs: {
            href: "#/user/deviceId?device_id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "city_master" ? _c("el-link", {
          attrs: {
            href: "#/user/city-master?phone=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v("查看详情")]) : _vm._e(), scope.row.operationType == "feedback" ? _c("el-link", {
          attrs: {
            href: "#/complaint/feedback?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "complain" ? _c("el-link", {
          attrs: {
            href: "#/complaint/list?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "order" && scope.row.operationOrderType == "quarter" ? _c("el-link", {
          attrs: {
            href: "#/quarter/orderRecord?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "order" && scope.row.operationOrderType == "quarter_deposit" ? _c("el-link", {
          attrs: {
            href: "#/quarter/deposit?serialNumber=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "order" && scope.row.operationOrderType == "member_refund" ? _c("el-link", {
          attrs: {
            href: "#/order/member?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : _vm._e(), scope.row.operationType == "quarter_company" ? _c("el-link", {
          attrs: {
            href: "#/quarter/company?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v("查看公司详情")]) : _vm._e(), scope.row.operationType == "lifestyle" ? _c("el-link", {
          attrs: {
            target: "_blank",
            href: "".concat(_vm.baseUrl, "lifestyle/detail?id=").concat(scope.row.detailBatchNo),
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailNo))]) : _vm._e(), scope.row.operationType == "community" ? _c("el-link", {
          attrs: {
            target: "_blank",
            href: "".concat(_vm.baseUrl, "community/detail?id=").concat(scope.row.detailBatchNo),
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailNo))]) : _vm._e(), scope.row.operationType == "used" ? _c("el-link", {
          attrs: {
            target: "_blank",
            href: "".concat(_vm.baseUrl, "second-hand/detail?id=").concat(scope.row.detailBatchNo),
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailNo))]) : _vm._e(), scope.row.operationType == "coupon_configure" && scope.row.buttonId == "coupon_configure_singleusertargeting" ? _c("el-link", {
          attrs: {
            href: "#/coupon/record?code=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : scope.row.operationType == "coupon_configure" ? _c("el-link", {
          attrs: {
            href: "#/coupon/config?code=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : scope.row.operationType == "payment" ? _c("el-link", {
          attrs: {
            target: "_blank",
            href: "#/quarter/paymentRecord?receiptWaterNbr=".concat(scope.row.detailBatchNo),
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : scope.row.operationType == "contract_dispute" ? _c("el-link", {
          attrs: {
            href: "#/capital/dispute?disputeCode=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))]) : scope.row.operationType == "complaint" ? _c("el-link", {
          attrs: {
            href: (scope.row.operationOrderType === "COMPLAINT" ? "#/complaint/list" : "#/complaint/quickList") + "?id=".concat(scope.row.detailBatchNo),
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v("查看投诉详情")]) : _vm._e(), scope.row.operationType == "text" ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            title: "",
            width: "200",
            trigger: "hover",
            content: scope.row.detailBatchNo
          }
        }, [_c("span", {
          staticClass: "text",
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.detailBatchNo))])]) : _vm._e(), scope.row.houseCode && scope.row.houseId ? _c("wlc-house-table-number", {
          attrs: {
            number: scope.row.houseCode,
            id: scope.row.houseId
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };